import { ALLOWED_ENVIRONMENTS, BASE_URLS } from './constants';

/**
 * Determines if the current environment is allowed to access the deeplink generator.
 * Compares the current hostname against the allowed environment URLs from BASE_URLS.
 * @returns true if the current environment is LOCAL, DEV, or INT; false otherwise
 */
export const isDeeplinkGeneratorAllowed = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const currentHostname = window.location.hostname.toLowerCase();

  // Check each allowed environment
  for (const env of ALLOWED_ENVIRONMENTS) {
    const envUrl = BASE_URLS[env];
    if (!envUrl) continue;

    try {
      const url = new URL(envUrl);
      const envHostname = url.hostname.toLowerCase();

      // Match exact hostname or localhost variations
      if (
        currentHostname === envHostname ||
        (env === 'LOCAL' &&
          (currentHostname === 'localhost' ||
            currentHostname.startsWith('127.')))
      ) {
        return true;
      }
    } catch {
      // Invalid URL, skip
      continue;
    }
  }

  return false;
};
